export default "<div class=main-table-w> <div class=body-header><h2>Plants</h2></div> <table cellpadding=1 cellspacing=1 class=history-t> <tr> <th>Plant Number</th> <th>Plant Name</th> <th>Time Zone ID</th> </tr> <tr ng-repeat=\"plant in plantsCtrl.plants | orderBy: 'name'\" ng-click=plantsCtrl.editPlant(plant)> <td>{{ plant.plantNumber }}</td> <td>{{ plant.name }}</td> <td>{{ plant.timeZoneId }}</td> </tr> <tr colspan=3 ng-if=!plantsCtrl.hasPlants()> <td>No Plants Loaded</td> </tr> </table> <div></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/plants/plants.tpl.html
// module id = 786
// module chunks = 0